import { css } from 'styled-components';
import { NavHeading } from '../../../../../components/InPageNav/InPageNavDesktop/styles';
import { colors } from '../../../colors';
import { fonts } from '../../../fonts';

export default css`
  ${NavHeading} {
    color: ${colors.neutral01};
    ${fonts.headingSmall};
  }
`;
